module.exports = {"dropDownPlaceholder":"Adobe ID 없이 로그인"}


//////////////////
// WEBPACK FOOTER
// ./src/components/SolutionsDropdown/__localization__/SolutionsDropdown/ko_kr.json
// module id = 932
// module chunks = 0